(function(ObjectUtils) {
    function isObjectEqual(a, b) {
        const aProps = Object.getOwnPropertyNames(a);
        const bProps = Object.getOwnPropertyNames(b);
        if (aProps.length != bProps.length) {
            return false;
        }
        for (const propName of aProps){
            if (a[propName] !== b[propName]) return false;
        }
        return true;
    }
    // http://adripofjavascript.com/blog/drips/object-equality-in-javascript.html
    ObjectUtils.isObjectEqual = isObjectEqual;
    function arrayToObjectWithIndexesAsKeys(array) {
        const object = {};
        for(let i = 0; i < array.length; i++){
            object[i] = array[i];
        }
        return object;
    }
    ObjectUtils.arrayToObjectWithIndexesAsKeys = arrayToObjectWithIndexesAsKeys;
    function removeAllPropertiesEqualTo(object, value) {
        for(const key in object){
            if (object[key] === value) {
                delete object[key];
            }
        }
    }
    ObjectUtils.removeAllPropertiesEqualTo = removeAllPropertiesEqualTo;
    function isNestedObjectEmpty(obj) {
        for(const key in obj){
            const property = obj[key];
            if (Array.isArray(property)) return false;
            const isPropertyObject = typeof property === 'object' && property !== null;
            if (!isPropertyObject) return false;
            if (!isNestedObjectEmpty(property)) return false;
        }
        return true;
    }
    ObjectUtils.isNestedObjectEmpty = isNestedObjectEmpty;
})(ObjectUtils || (ObjectUtils = {}));
export function objectAsType(object, type) {
    if (object instanceof type) {
        return object;
    }
    throw new Error(`Object is not a ${type.name}`);
}
export var ObjectUtils;
